import { Cell, Input, Row } from '@dexma/ui-components';
import { FooterInputText } from 'adapter/in/common/components/Text';
import { StyledRowActivableInput, StyledWidgetTextInput } from 'adapter/in/common/components/Text/style';
import PresetFormFieldProperties from 'domain/entity/preset/form/presetFormFieldProperties';
import React, { memo } from 'react';

export type WidgetNumberType = {
    error: boolean;
    errorMessage?: string;
    label: string;
    name: string;
    dataTestId: string;
    footer: string;
    isLoading?: boolean;
    properties?: PresetFormFieldProperties;
    onChange: (value: string) => void;
    value: string;
};

const FormInputNumber = memo((props: WidgetNumberType) => {
    const { label, error, errorMessage, name, footer, properties, dataTestId, isLoading, onChange, value } = props;
    const placeholder = properties?.placeholder ? properties.placeholder : undefined;

    const handleChange = (event: { target: { value: string } }) => {
        onChange(event.target.value);
    };

    return (
        <StyledWidgetTextInput $error={error}>
            <Row>
                <Cell className='widget-type-block'>
                    <span>{label}</span>
                </Cell>
            </Row>
            <StyledRowActivableInput>
                <Cell>
                    <Input
                        type='number'
                        name={name}
                        label={name}
                        placeholder={placeholder}
                        disabled={isLoading}
                        onChange={handleChange}
                        data-testid={dataTestId}
                        value={value}
                    />
                    {error && <div className='error'>{errorMessage}</div>}
                </Cell>
            </StyledRowActivableInput>
            {footer && <FooterInputText text={footer} />}
        </StyledWidgetTextInput>
    );
});

export default FormInputNumber;
